/* ---- burr toast ----------------------------------------------------------
   You are tangled in a burr bush; packages/engine/src/burrs.js shows and hides it off
   the local player's own tangle.  It takes #charge's slot -- bottom-centre,
   where the player's eyes already are -- because the two can never show at
   once: a tangled cat cannot gather a pounce.  Entry/exit borrowed from
   #charge for #bliss's reason.  .sting is the server's word (the `burr`
   broadcast) that the happiness cost just landed: the border takes the
   bush's own rust, so the dip on the meter arrives with a visible cause. */
#burr{left:0;right:0;margin:0 auto;bottom:46px;width:230px;padding:9px 15px;
  pointer-events:none;text-align:center;
  z-index:4;opacity:0;visibility:hidden;transform:translateY(10px) scale(.96);
  transition:opacity .26s ease-in,transform .26s ease-in,visibility 0s .26s}
#burr.show{opacity:1;visibility:visible;transform:none;
  transition:opacity .12s ease-out,transform .12s ease-out}
#burr b{display:block;font-family:"Archivo",system-ui,sans-serif;font-weight:800;
  font-size:.92rem;letter-spacing:-.02em}
#burr span{font-size:.64rem;letter-spacing:.13em;text-transform:uppercase;
  color:var(--dim)}
#burr.sting{border-color:#9a6a2f}
#burr.sting span{color:#9a6a2f}
